import { jsx as t } from "react/jsx-runtime";
import { Popper as N } from "@mui/material";
import O from "@mui/material/Autocomplete";
import l from "styled-components";
import z from "../../icons/chevron-down.js";
import M from "../../icons/clear.js";
import { getBackground as T, variants as g, getBackgroundHover as $ } from "../../theme/utils/styleUtils.js";
import B from "../Checkbox/Checkbox.js";
import U from "../Chip/Chip.js";
import D from "../Menu/components/MenuItem.js";
import E from "../Menu/components/MenuList.js";
import j from "../TextField/TextField.js";
const H = {
  root: "autoCompleteRoot",
  clearIndicator: "autoCompleteClearIndicator",
  endAdornment: "autoCompleteEndAdornment",
  inputRoot: "autoCompleteInputRoot",
  popupIndicator: "autoCompletePopupIndicator",
  popupIndicatorOpen: "autoCompletePopupIndicatorOpen",
  paper: "menuPaper",
  list: "menuList",
  option: "menuOption",
  groupLabel: "menuGroupLabel",
  groupUl: "menuGroupUl",
  hasPopupIcon: "hasPopupIcon",
  hasClearIcon: "hasClearIcon"
}, q = l(N).withConfig({
  displayName: "Popper"
})([
  "&& .menuPaper{box-shadow:0 4px 20px 0 ",
  ";margin-top:4px;margin-bottom:4px;box-sizing:border-box;}&& .menuList{padding:0;}&& .menuOption.Mui-focused{background-color:transparent;}& .menuGroupLabel{padding:0px 8px;color:",
  ";font-size:",
  ";line-height:34px;}& .menuGroupUl{padding:0px 8px;}"
], ({ theme: o }) => o.primaryShadow, ({ theme: o }) => o.text.tertiary, ({ theme: o }) => o.typography.body100.fontSize), J = l(z).withConfig({
  displayName: "ArrowDownIcon"
})([
  "width:10px;height:10px;color:",
  ";"
], ({ theme: o }) => o.text.primary), K = l(O).withConfig({
  displayName: "StyledAutocomplete"
})([
  "&& .autoCompletePopupIndicator{transition:transform 0.25s linear;transform:rotate(0deg);&:hover{background-color:transparent;}}&& .autoCompletePopupIndicatorOpen{transform:rotate(-180deg);}& .autoCompleteClearIndicator{width:16px;height:16px;color:",
  ";& + .autoCompletePopupIndicator{margin-left:10px;}&:hover{color:",
  ";}svg{flex-shrink:0;width:16px;height:16px;}}&&.hasPopupIcon .autoCompleteInputRoot{padding-right:20px;}&&.hasClearIcon .autoCompleteInputRoot{padding-right:20px;}&&.hasPopupIcon.hasClearIcon .autoCompleteInputRoot{padding-right:42px;}"
], ({ theme: o }) => T(o, g.contained, o.isLightTheme ? o.colors.grey500 : o.colors.darkGrey300), ({ theme: o }) => $(o, g.contained, o.isLightTheme ? o.colors.grey500 : o.colors.darkGrey300)), Q = l(j).withConfig({
  displayName: "StyledTextField"
})([
  "&& button.clearTextButtonIcon{margin-right:",
  ";}"
], ({ $freeSolo: o, $forcePopupIcon: d }) => o && !d ? "8px" : "30px"), V = ({
  className: o,
  classes: d,
  ChipProps: h,
  label: f = void 0,
  tooltip: I = void 0,
  TextFieldProps: n = void 0,
  // @ts-expect-error - TODO: fix this type.
  getOptionLabel: i = (r) => (r == null ? void 0 : r.label) ?? r,
  renderInput: x,
  renderOption: C,
  renderTags: y,
  onChange: u,
  disableClearable: b,
  multiple: m,
  useCheckbox: w = !1,
  freeSolo: c,
  forcePopupIcon: s,
  clearIcon: v = /* @__PURE__ */ t(M, {}),
  PopperComponent: k = q,
  popupIcon: A = /* @__PURE__ */ t(J, {}),
  ListboxComponent: P = E,
  ...R
}) => {
  const r = (a, e, { selected: p }) => w ? /* @__PURE__ */ t("li", {
    ...a,
    children: /* @__PURE__ */ t(B, {
      checked: p,
      label: i(e)
    })
  }) : /* @__PURE__ */ t(D, {
    ...a,
    selected: p,
    children: i(e)
  }), G = (a, e) => a.map((p, L) => /* @__PURE__ */ t(U, {
    label: i(p),
    size: "small",
    ...e({
      index: L
    }),
    ...h
  })), S = (a) => /* @__PURE__ */ t(Q, {
    onClear: (e) => {
      const p = {
        ...e,
        target: {
          ...e.target,
          value: void 0
        }
      };
      u && u(p, m ? [] : null, "clear", void 0);
    },
    $freeSolo: c,
    $forcePopupIcon: s,
    label: f,
    tooltip: I,
    ...a,
    ...n
  });
  return (
    // @ts-expect-error - TODO: fix this type.
    /* @__PURE__ */ t(K, {
      className: o,
      classes: {
        ...H,
        ...d
      },
      renderInput: x || S,
      getOptionLabel: i,
      onChange: u,
      disableClearable: (n == null ? void 0 : n.disableClear) === !1 ? !0 : b,
      multiple: m,
      freeSolo: c,
      forcePopupIcon: s,
      ...R,
      renderTags: y || G,
      renderOption: C || r,
      clearIcon: v,
      PopperComponent: k,
      popupIcon: A,
      ListboxComponent: P
    })
  );
};
V.displayName = "Autocomplete";
export {
  V as default
};
